import React, { useRef, useCallback } from 'react';
import { KiteCard, KiteAlert } from '@kite/react-kite';
import { ITCOForm, ITCOSubmission } from 'types';
import { useTCORenderFields } from 'hooks';
import './TCODealStructure.scss';

export interface ITCODealStructureProps {
  /** Form data from query */
  form: ITCOForm;
  tcoSubmissions: ITCOSubmission[];
}

const TCODealStructure = ({ form, tcoSubmissions }: ITCODealStructureProps) => {
  const { name, fields, id } = form;

  const ref = useRef<HTMLFormElement>(null);

  const { fieldComponents, updateTcoSubmissionsError } = useTCORenderFields({
    fields,
    tcoSubmissions,
    formId: id,
  });

  const handleSubmit = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    // could add manual save here if needed
    e.preventDefault();
  }, []);

  return (
    <KiteCard className="tco-deal-structure">
      <h2 className="tco-deal-structure__title">{name}</h2>
      <div className="acquisition-costs">
        {updateTcoSubmissionsError && (
          <KiteAlert
            type="alert"
            title="Save Error"
            description="Something went wrong saving your answers. Any changes will not be saved. Please refresh and try again later."
          />
        )}
        <form
          ref={ref}
          onSubmit={handleSubmit}
          className={'acquisition-costs__row'}
        >
          {fieldComponents}
        </form>
      </div>
    </KiteCard>
  );
};

export default TCODealStructure;
